


import React, { FunctionComponent, useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Divider,
  Grid,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';

import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { getDocumentThumb, getFileType, Tenant } from '@ivymobi/orbit-core';
import QuickStart from '../dashboard/quickStart';
import Title from '../components/views/title';
import Menus, { OpenMenuItem } from '../components/views/menuItem';
import { getAllCatalogsAction, getCatlogsAction, getControlsAction, getProductSelectionCgIDAction, getProductSelectionRobotAction, getRobotLocalesAction, useModelOptions } from '@ivymobi/orbit-core/business/productCenter';
import { filter, isUndefined, union } from 'lodash';
import { DeviceType, WebSiteContext } from '../orbit-context';
import ZTree from './component/zTree';
import './selections.css'
import RobotSearch from './component/robotSearch';
import ProductItem from './component/productItem';
import { Favorite, Share } from '@mui/icons-material';
import { TabPanel } from '../components';
import { IvymobiTabs } from '../components/IvymobiTabs';
import SelectionItem from './component/selectionItem';
import _ from 'lodash';
import { el } from 'date-fns/locale';
import { modelOptionsAction, useOptions } from '@ivymobi/orbit-core/business/user';
import ControlPanel from './component/controlPanel';
import { getOutLibDocumentsAction } from '@ivymobi/orbit-core/business/share';
import { DocumentGridCard } from '../documents/grid';
import { getTitle, getTitleById } from './mapping';
import fullTexts from './fullTexts';
import RichText from '../components/richText/RichTextRenderer';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'column',
    height:'100%',
    alignItems:'center'
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)  },


}));
let items = [{
  name:'总部',
  id:10001,
  children:[
    {
      name:'中国总部',
      address:'上海市虹桥路1386号三菱电机自动化中心',
      postcode:'200336',
      tel:'86-21-2322-3030',
      fax:'021-23223030'
    }
  ]
  
},{
  name:'分公司/办事处',
  id:10002,
  children:[
    {name:"华东-温州",address:"浙江省温州市鹿城区大南路温州世贸中心大厦5001室-7",tel:"86-0577-8857-3697"},
    {name:"华东-常熟",address:"江苏常熟高新技术产业开发区黄浦江路133号"},
    {name:"华东-无锡",address:"无锡市南长区运河东路557号B栋2221室",tel:"86-510-8512-6335"},
    {name:"华东-青岛",address:"青岛市高新区科海路333号办公楼一楼",tel:"86-532-8790-5028	"},			
    {name:"华东-宁波",address:"宁波市海曙区南站东路16号月湖银座大厦612-613室",tel:"86-574-8730-0815"},
    {name:"华东-合肥",address:"安徽省合肥市蜀山区怀宁路288号置地广场D座802-803室",tel:"86-551-6515-1300"},
    {name:"华东-武汉",address:"武汉市江汉区云霞路187号 泛海国际中心 A单元904B室",tel:"86-27-8555-8045（FA）86-27-8555-8041（CNC）86-27-8555-8043（行业）"},
    {name:"华东-苏州",address:"苏州市苏州工业园区苏州中心办公楼C座06层601、608室",tel:"86-512-6258-8830"},
    {name:"华东-上海",address:"上海市虹桥路1386号三菱电机自动化中心",tel:"86-21-2322-3030"},
    {name:"华南-长沙",address:"湖南省长沙市岳麓区环湖路1177号金茂广场南塔1718室",tel:"86-731-8229-0957"},
    {name:"华南-厦门",address:"福建省厦门市湖里区高崎南五路212号中骏大厦第三座304单元",tel:"86-592-5728-130"},
    {name:"华南-广州",address:"广州市番禺区钟村街汉溪大道东276-282号 时代E-PARK A1栋1006",tel:"86-20-8923-6730"},
    {name:"华南-深圳",address:"深圳市龙岗区雅宝路1号星河WORLD B栋大厦8层",tel:"86-755-2399-8272"},
    {name:"华北-郑州",address:"河南省郑州市金水区文化路68号数码港1016室",tel:"86-371-6913-6201"},
    {name:"华北-西安",address:"西安市雁塔区二环南路88号 老三届·世纪星大厦24层D-E室",tel:"86-29-8730-5236"},
    {name:"华北-天津",address:"天津市河西区友谊路35号城市大厦3203、3204 B室",tel:"86-22-2813-1015"},
    {name:"华北-北京",address:"北京市朝阳区酒仙桥路20号颐堤港一座第5层504-506号",tel:"86-10-6518-8830"},
    {name:"西南-重庆",address:"重庆市九龙坡区（县）石杨路18号江厦星光汇1幢8- 4、8-5",tel:"86-23-6816-2680"},
    {name:"西南-成都",address:"成都市青羊区光华北三路98号光华中心C栋15楼1501~1502号",tel:"86-28-8446-8030"},
    {name:"东北-沈阳",address:"沈阳市和平区和平北大街69号总统大厦C座2302室",tel:"86-24-2259-8830"},			
    {name:"东北-大连",address:"大连市经济技术开发区东北区三街5号",tel:"86-411-8765-5951"},		
  ]
  
},{
  name:'FA中心',
  id:10003,
  children:[
    {name:"上海FA中心",address:"上海市虹桥路1386号三菱电机自动化中心",tel:"86-21-2322-3030"},		
    {name:"深圳FA中心",address:"深圳市龙岗区雅宝路1号星河WORLD B栋大厦8层",tel:"86-755-2399-8272"},		
    {name:"广州FA中心",address:"广州市番禺区钟村街汉溪大道东276-282号时代E-PARK A1栋1006",tel:"86-20-8923-6730"},		
    {name:"天津FA中心",address:"天津市河西区友谊路35号城市大厦3203、3204 B室",tel:"86-22-2813-1015"},		
    {name:"北京FA中心",address:"北京市朝阳区酒仙桥路20号颐堤港一座第5层504-506号",tel:"86-10-6518-8830"},	
  ]
  
},{
  name:'培训中心',
  id:10004,
  children:[
    {name:"上海培训中心",address:"上海市虹桥路1386号三菱电机自动化中心",tel:"86-21-2322-3030*3157（FA） 86-21-2322-3030*2828（CNC）"},		
    {name:"深圳培训中心",address:"深圳市龙华区雅宝路1号星河WORLD 二期 三菱电机智能制造科创中心",tel:"86-755-2399-8272*6892（FA）"},		
    {name:"广州培训中心",address:"广州市番禺区钟村街汉溪大道东276-282号时代E-PARK A1栋1006",tel:"86-20-8923-6730*802（FA）86-21-2322-3030*2828（CNC）"},		
    {name:"深圳培训中心",address:"深圳市龙岗区雅宝路1号星河WORLD B栋大厦8层",tel:"86-21-2322-3030*2828（CNC） 86-755-2399-8272*6892（ROBOT）"},		
    {name:"西安培训中心",address:"西安市雁塔区二环南路88号 老三届·世纪星大厦24层D-E室",tel:"86-29-8730-5236*305（FA）  86-21-2322-3030*2828（CNC）"},		
    {name:"天津培训中心",address:"天津市河西区友谊路35号城市大厦3203、3204 B室",tel:"86-10-6518-8830*608（FA）  86-21-2322-3030*2828（CNC）"},		
    {name:"北京培训中心",address:"北京市朝阳区酒仙桥路20号颐堤港一座第5层504-506号",tel:"86-10-6518-8830*608（FA）  86-21-2322-3030*2828（CNC）"},		
    {name:"成都培训中心",address:"成都市青羊区光华北三路98号 光华中心C栋15楼1501～1502号",tel:"86-28-8446-8030*3024（FA）  86-21-2322-3030*2828（CNC）"},		
    {name:"大连培训中心",address:"大连市经济技术开发区东北区三街5号",tel:"86-411-8765-5951"},	
  ]
  
},{
  name:'联合培训中心',
  id:10005,
  children:[
    {name:"南京工程学院",address:"南京市江宁科学园弘景大道1号",tel:"86-25-8611-8578"},
  ]
  
},{
  name:'授权技术培训站',
  id:10006,
  children:[
    {name:"苏州授权技术培训站",address:"苏州市新区湘江路南创业街60号",tel:"86-512-6807-3627"},		
    {name:"张家港授权技术培训站",address:"张家港市邵巷北路38号华怡商务4楼",tel:"86-512-5638-2189"},		
    {name:"苏州授权技术培训站",address:"苏州市平江区人民路3188号万达广场C座14楼12B03室",tel:"86-512-6533-5409"},		
    {name:"上海授权技术培训站",address:"上海市徐汇区漕宝路86号1601室",tel:"86-21-5109-6030"},		
    {name:"青岛授权技术培训站",address:"青岛市高新区科海路333号",tel:"86-532-8380-8370"},		
    {name:"杭州授权技术培训站",address:"杭州市西湖区西园一路16号钱江奔腾科技园4号楼505室",tel:"86-571-8821-5383"},		
    {name:"杭州授权技术培训站",address:"杭州市西湖区荆山岭路2号汇峰国际D座2楼206室",tel:"86-571-8893-5200"},		
    {name:"深圳授权技术培训站",address:"深圳市龙华新区观澜街道观湖社区金雄达科技园E栋二楼",tel:"86-755-8835-2540"},		
    {name:"深圳授权技术培训站",address:"深圳市罗湖区东门南路华都园大厦26楼J/K",tel:"86-755-2589-5229"},		
    {name:"深圳授权技术培训站",address:"深圳市南山区科技园南区达实大厦801",tel:"86-755-8347-8321"},		
    {name:"广州授权技术培训站",address:"广州市黄埔区骏雅北街3号902房",tel:"86-20-3239-8579*823"},		
    {name:"东莞授权技术培训站",address:"东莞市南城区黄金路1号天安数码城A1栋1309",tel:"86-769-2309-9020"},		
    {name:"郑州授权技术培训站",address:"郑州市文化路68号河南科技市场数码港10楼109B室",tel:"86-371-6396-5378*8021"},		
    {name:"天津授权技术培训站",address:"天津市红桥区湘潭中路23号绿建吉地C-202",tel:"86-22-2738-0521"},		
    {name:"北京授权技术培训站",address:"北京市海淀区知春路甲63号，卫星大厦11层1106室",tel:"86-10-8286-7930*881"},			
  ]
},
{
  name:'售后服务中心',
  id:10007,
  children:[
    {name:"无锡售后服务中心",address:"无锡市南长区运河东路557号栋2221室",tel:"86-510-8512-6335"},
    {name:"合肥售后服务中心",address:"安徽省合肥市蜀山区怀宁路288号置地广场D座802-803室",tel:"86-551-6515-1300"},
    {name:"武汉售后服务中心",address:"武汉市江汉区云霞路187号 泛海国际中心A单元904B",tel:"86-27-8555-8041"},
    {name:"苏州售后服务中心",address:"苏州市苏州工业园区 苏州中心办公楼C座 06层601、608室",tel:"86-512-6258-8830"},
    {name:"上海售后服务中心",address:"上海市虹桥路1386号三菱电机自动化中心",tel:"86-21-2322-3030"},
    {name:"青岛售后服务中心",address:"青岛市高新区科海路333号办公楼一楼	86-532-8790-5028"},
    {name:"宁波售后服务中心",address:"宁波市海曙区南站东路16号月湖银座大厦612-613室",tel:"86-754-8730-0815"},
    {name:"厦门售后服务中心",address:"福建省厦门市湖里区高崎南五路212号中骏大厦第三座304单元",tel:"86-592-5728-130"},
    {name:"深圳售后服务中心",address:"深圳市龙岗区雅宝路1号星河WORLD B栋大厦8层",tel:"86-755-2399-8272"},
    {name:"西安售后服务中心",address:"西安市雁塔区二环南路88号 老三届·世纪星大厦24层D-E室",tel:"86-29-8730-5236"},
    {name:"天津售后服务中心",address:"天津市河西区友谊路35号城市大厦3203、3204 B室",tel:"86-22-2813-1015"},
    {name:"北京售后服务中心",address:"北京市朝阳区酒仙桥路20号颐堤港一座第5层504-506号",tel:"86-10-6518-8830"},
    {name:"成都售后服务中心",address:"成都市青羊区光华北三路98号 光华中心C栋15楼1501～1502号",tel:"86-28-8446-8030"},
    {name:"大连售后服务中心",address:"大连市经济技术开发区东北区三街5号",tel:"86-411-8765-5951"},
  ]
  
},{
  name:'授权维修站',
  id:10008,
  children:[
    
    {name:"苏州授权维修站",address:"江苏省苏州市姑苏区人民路3188好万达广场C座12B03",tel:"86-512-6935-6320"},		
    {name:"合肥授权维修站",address:"安徽省合肥市政务文化新区齐云山路与天鹅湖路交叉口蔚蓝商务港D座2221室",tel:"86-551-6575-1930"},		
    {name:"苏州授权维修站",address:"江苏省苏州市新区湘江路南创业街60号",tel:"86-512-6807-3627"},		
    {name:"苏州授权维修站",address:"江苏省苏州市高新区浒墅关镇长亭路9号2栋210室",tel:"86-512-66905530"},		
    {name:"张家港授权维修站",address:"张家港市杨舍镇邵巷北路38号华怡商务楼4楼",tel:"86-512-5638-2105"},		
    {name:"无锡授权维修站",address:"无锡市锡山区东北塘街道农新河路111号301室",tel:"86-510-8232-2661"},		
    {name:"青岛授权维修站",address:"青岛高新区科海路333号金文科技",tel:"86-532-6696-9070"},		
    {name:"昆山授权维修站",address:"江苏省昆山开发区创业路1588号象屿两岸贸易中心7号楼809号室",tel:"86-512-5792-3538"},		
    {name:"杭州授权维修站",address:"浙江省杭州市西湖区西园一路16号钱江奔腾科技园4号楼505室",tel:"86-571-8821-1539"},		
    {name:"杭州授权维修站",address:"杭州市西湖区荆山岭路2号汇峰国际D座2楼206",tel:"86-571-8893-5203"},		
    {name:"常熟授权维修站",address:"常熟市黄浦江路133号平谦国际产业园3号厂房",tel:"86-512-5233-0111"},		
    {name:"深圳授权维修站",address:"深圳市罗湖区东门南路华都园大厦26楼J/K",tel:"86-755-2510-1269"},		
    {name:"深圳授权维修站",address:"深圳市南山区科技园南区达实大厦801",tel:"86-755-8347-8321"},		
    {name:"佛山授权维修站",address:"广东省佛山市普澜二路8号二楼",tel:"86-757-8332-4660"},		
    {name:"东莞授权维修站",address:"东莞市南城区黄金路1号东莞天安数码城A1栋1309",tel:"86-769-2309-9020"},		
    {name:"郑州授权维修站",address:"郑州市文化路68号河南科技市场数码港109B室",tel:"86-371-6396-5378"},		
    {name:"北京授权维修站",address:"北京市海淀区知春路63号北京卫星制造厂51号楼（卫星大厦）11层1101室",tel:"86-10-8286-7930"},		
    {name:"重庆授权维修站",address:"重庆市石桥铺科园一路渝高广场D座15-3",tel:"86-23-6850-9006"},
  ]
  
}]
const scrollToAnchor =(anchorName) =>{
  if (anchorName) {
    // 找到锚点
    let anchorElement = document.getElementById(anchorName);
    console.log("anchorElement============",anchorElement)
    // 如果对应id的锚点存在，就跳转到锚点
    if(anchorElement) { anchorElement.scrollIntoView({block: 'start', behavior: 'smooth'}); }
}
}
const Item = (props)=>{
  const deviceType = useContext(DeviceType);

  const item = props.item;
  return <Box id={item.id}>
   <Box style={{display:'flex',flexDirection:'row',alignItems:'center'}}><Box ><Box className='float-flag'></Box></Box> 
    <Box style={{fontWeight:'600',fontSize:'20px'}}>{item.name}</Box></Box>
    <Box style={{display:'flex',flexWrap:'wrap'}}>
     {item.children.map((citem)=>{
      return <Box style={{width:deviceType==='computer'?'50%':'100%'}}>
     {citem.name&&<p style={{fontWeight:'400',fontSize:'1rem',marginTop:'25px',marginBottom:'5px'}}>{citem.name}</p>} 
     {citem.address&&<p style={{fontWeight:'400',fontSize:'1rem',marginTop:'8px',marginBottom:'5px'}}>地址：{citem.address}</p>} 
    {citem.pstcode&&<p style={{fontWeight:'400',fontSize:'1rem',marginTop:'8px',marginBottom:'5px'}}>邮编：{citem.postcode}</p>} 
    {citem.tel&&<p style={{fontWeight:'400',fontSize:'1rem',marginTop:'8px',marginBottom:'5px'}}>电话：{citem.tel}</p>} 
    {citem.fax&&<p style={{fontWeight:'400',fontSize:'1rem',marginTop:'8px',marginBottom:'5px'}}>传真：{citem.fax}</p>} 

      </Box>
     })} 
      
      
    </Box>
    <Box style={{width:'100%',height:'1px',background:'#e3e2e2',marginTop:'30px',marginBottom:'30px'}}></Box>

    </Box>
}
export const ContactView = (props) => {

  
  const classes = useStyles(); 
  const deviceType = useContext(DeviceType);

  const getAbout =()=>{
   

    for(let i=0;i<fullTexts.length;i++){
      let _text = fullTexts[i];
      
      if(_text.name==='联系我们'){
        return _text.children;
      }
    }
  }
  let abouts = getAbout();
  useEffect(()=>{
    props.setTitle('联系我们')
    props.setParents([])
  },[])
  return (
    <div style={{height:'calc(100% - 30px)'}}>
      {deviceType==='computer'&&<Breadcrumbs style={{height:'30px'}} separator=">" maxItems={8}>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={null}
          component={RouteLink}
        >
          联系我们
        </Link>
      </Breadcrumbs>} 
      <Box className={classes.pages}>

        <Box style={{width:deviceType==='computer'?'80%':'100%',paddingTop:'10px',paddingBottom:'16px',height:'100%',display:'flex',flexDirection:'column' }}> 
        <Title name={'联系我们'}></Title>

        <Box style={{background:'white',padding:'40px', position:'relative'}}>
          <p>三菱电机自动化拥有遍布全国的销售/服务网络，为您提供高效可信赖的支持和服务，为全球化的客户提供强大支持。</p>
          <p>快速跳转：
            {items.map((item)=>{
              return  <a style={{marginLeft:'14px',textDecoration:'underline',cursor:'pointer',color:'blue'}} onClick={()=>{
                scrollToAnchor(item.id);
              }}>{item.name}</a>
            })}
           
          
          </p>
          {items.map((item)=>{
            return <Item item ={item}></Item>
          })}
          <Box  style={{position:'absolute'}}>
            <img  onClick={()=>{
                // scrollToAnchor('top')
                let anchorElement = document.getElementById('top');
                anchorElement.scrollTo({top:0})

}} style={{position:'fixed',bottom:'40px',right:'10vw',zIndex:100000,width:'60px',height:'60px',cursor:'pointer'}} src="/images/toTop.png"></img>


          </Box>
        </Box>
          
        </Box>
        

      </Box>
    </div>
  );
};


export default function ContactContainer (props) {

  return (
    <ContactView {...props}

    />
  );
}
